import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ec-filter',
  templateUrl: './ec-filter.component.html',
  styleUrls: ['./ec-filter.component.css']
})
export class EcFilterComponent implements OnInit {
  form: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  ECdata: any = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any

  filterBy = ""
  filterByMobileOrEmailOrDeviceId = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    // this.getAllEC();
    this.form = this.fb.group({
      existingCustomerInfoId: [''],
    })  
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllEC();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllEC();
  }

  getAllEC(){
    this.generic_service.getAllExistingCustomerInfo().subscribe(
      (response:any)=>{
        this.ECdata = response.response;
        console.log(response)
      }
    )
  }

  getECbyId(id:any){
    this.generic_service.getExistingCustomerById(id).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);
      }
    )
  }

  getExistingCustomerByMobile(mobile:any){
    this.generic_service.getExistingCustomerByMobile(mobile).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);
      }
    )
  }

  getExistingCustomerByDeviceId(deviceId:any){
    this.generic_service.getExistingCustomerByDeviceId(deviceId).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);
      }
    )
  }

  getExistingCustomerByEmail(email:any){
    this.generic_service.getExistingCustomerByEmail(email).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);
      }
    )
  }

  getExistingCustomerByFilter(){
    if(this.filterBy != ""){
      if(this.filterBy == "mobile"){
        this.getExistingCustomerByMobile(this.filterByMobileOrEmailOrDeviceId)
      }else{
        this.getExistingCustomerByDeviceId(this.filterByMobileOrEmailOrDeviceId)
      }
    }else{
      this.toastr.error('Select Filter')
    }
  }


}
